import { getConfigPropertyAtomCreator as r, ConfigProperty as _ } from "./index13.mjs";
import { useAtomValue as l } from "jotai";
import { useMemo as a } from "react";
var s = /* @__PURE__ */ ((t) => (t.INCORRECT_PRICE = "incorrect_price", t.CART_EMPTY = "cart_empty", t.INVALID_DATES = "invalid_dates", t.INVALID_ALLOCATION = "invalid_allocation", t.SALES_TERMS_NOT_ACCEPTED = "sales_terms_not_accepted", t.PAYMENT_TYPE_EMPTY = "payment_type_empty", t.ROOMS_NOT_AVAILABLE = "rooms_not_available", t.CART_ROOM_NOT_VALID = "cart_room_not_valid", t.PAYMENT_TYPE_ERROR = "payment_type_error", t))(s || {});
const c = () => {
  const t = l(
    a(() => r(_.HOTEL_EMAIL), [])
  ), n = {
    incorrect_price: {
      title: I18n.t("booking_engine.errors.incorrect_price.title"),
      subTitle: I18n.t("booking_engine.errors.incorrect_price.sub_title"),
      stepToReturn: 2
    },
    cart_empty: {
      title: I18n.t("booking_engine.errors.cart_empty.title"),
      subTitle: I18n.t("booking_engine.errors.cart_empty.sub_title"),
      buttonLabel: I18n.t("booking_engine.errors.cart_empty.button_label"),
      isShowCloseButton: !1,
      stepToReturn: 1
    },
    invalid_dates: {
      title: I18n.t("booking_engine.errors.invalid_dates.title"),
      subTitle: I18n.t("booking_engine.errors.invalid_dates.sub_title"),
      buttonLabel: I18n.t(
        "booking_engine.errors.rooms_not_available.button_label"
      ),
      stepToReturn: 0
    },
    invalid_allocation: {
      title: I18n.t("booking_engine.errors.invalid_allocation.title"),
      subTitle: I18n.t("booking_engine.errors.invalid_allocation.sub_title"),
      buttonLabel: I18n.t("booking_engine.information.add_another_room"),
      stepToReturn: 1
    },
    sales_terms_not_accepted: {
      title: I18n.t("booking_engine.errors.sales_terms_not_accepted.title"),
      subTitle: I18n.t(
        "booking_engine.errors.sales_terms_not_accepted.sub_title"
      ),
      stepToReturn: 2
    },
    payment_type_empty: {
      title: I18n.t("booking_engine.errors.payment_type_empty.title"),
      subTitle: I18n.t("booking_engine.errors.payment_type_empty.sub_title"),
      stepToReturn: 2
    },
    rooms_not_available: {
      title: I18n.t("booking_engine.errors.rooms_not_available.title"),
      subTitle: I18n.t("booking_engine.errors.rooms_not_available.sub_title"),
      buttonLabel: I18n.t(
        "booking_engine.errors.rooms_not_available.button_label"
      ),
      stepToReturn: 1
    },
    cart_room_not_valid: {
      title: I18n.t("booking_engine.errors.cart_room_not_valid.title"),
      subTitle: I18n.t("booking_engine.errors.cart_room_not_valid.sub_title"),
      buttonLabel: I18n.t("booking_engine.errors.cart_empty.button_label"),
      stepToReturn: 1
    },
    payment_type_error: {
      title: I18n.t("booking_engine.errors.cannot_complete_booking.title"),
      subTitle: I18n.t("booking_engine.errors.get_in_touch_through_email", {
        email: t
      }),
      buttonLabel: I18n.t("booking_engine.information.got_it"),
      stepToReturn: 2
    }
  };
  return (i, o) => {
    const e = n[i];
    return {
      title: e.title,
      subTitle: e.subTitle,
      buttonLabel: e.buttonLabel,
      ...e.isShowCloseButton !== void 0 && {
        isShowCloseButton: e.isShowCloseButton
      },
      ...o && { onClose: () => o(e.stepToReturn) }
    };
  };
};
export {
  s as ErrorType,
  c as useErrorHandler
};
